import { render, staticRenderFns } from "./TimerOverlay.vue?vue&type=template&id=515fa452&scoped=true&lang=pug"
import script from "./TimerOverlay.vue?vue&type=script&lang=ts"
export * from "./TimerOverlay.vue?vue&type=script&lang=ts"
import style0 from "./TimerOverlay.vue?vue&type=style&index=0&id=515fa452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fa452",
  null
  
)

export default component.exports